import { createAction, createSlice } from "@reduxjs/toolkit";

const getAllCourseByInstructorSlice = createSlice({
  name: "getAllCourseByInstructor",
  initialState: { data: [], processing: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.data = action.payload.data.data;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getAllCourseByInstructorSlice;
const getAllCourseByInstructorAction = createAction(name);

export {
  getAllCourseByInstructorAction,
  actions as getAllCourseByInstructorActions,
  reducer as getAllCourseByInstructorReducer,
};
